export default __webpack_public_path__ + "static/media/fauna-sampleapp-tut.307003bb.png";